export default __webpack_public_path__ + "static/media/element_spec_44.987a1b76.jpg";